<div class="d-flex">
  <div class="tp-headline mb-0 mr-3">{{title|translate}}</div>
  <div class="align-self-end" *ngIf="validationRelease">{{'Common.Release'|translate}}: {{validationRelease.buildId}}</div>
</div>